// IMPORTAÇÃO DAS BIBLIOTECAS----------------------------------------------------------------------
import React, { useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { api } from '../../services/api.js';
import styles from './resetPassword.module.css';
import { useTranslation } from 'react-i18next';



// COMPONENTE--------------------------------------------------------------------------------------
const ResetPassword = () => {
    //variáveis
    const { token } = useParams(); //token recebido através da URL
    const navigate = useNavigate();
    const [password, setPassword] = useState(""); // estado para armazenar a senha
    const [passwordConfirm, setPasswordConfirm] = useState(""); // estado para armazenar a confirmação da senha
    const [message, setMessage] = useState(""); // estado para armazenar a mensagem de sucesso
    const [error, setError] = useState(""); // estado para armazenar a mensagem de erro
    const [loading, setLoading] = useState(false); // estado para armazenar o estado de carregamento
    const { t } = useTranslation(); // hook para tradução



    // função para enviar a confirmação da nova senha
    const handleSubmit = async (e) => {
        e.preventDefault();
        setError("");
        setMessage("");

        if (password !== passwordConfirm) {
            setError(t("Passwords do not match."));
            return;
        }
        if (!password || !passwordConfirm) {
            setError(t("Please fill in the password fields."));
            return;
        }

        setLoading(true);

        try {
            await api.post('/auth/reset-password', {
                token: token,
                password: password,
                passwordConfirm: passwordConfirm
            });
            setMessage(t("Password changed successfully! You will be redirected to the login page."));
            setPassword("");
            setPasswordConfirm("");
            
            setTimeout(() => {
                navigate("/");
            }, 3000);

        } catch (err) {
            setError(err.response?.data?.msg || err.message || t('An error occurred. Please try again.'));
        } finally {
            setLoading(false);
        }
    };



    // html do componente
    return (
        <div className={styles.page}>
            <div className={styles.container}>
                <h2 className={styles.title}>{t("Reset Password")}</h2>
                <p className={styles.subtitle}>{t("Choose a new password for your account.")}</p>
                <form onSubmit={handleSubmit} className={styles.form}>
                    <div className={styles.inputGroup}>
                        <label htmlFor="password" className={styles.label}>{t("New Password")}:</label>
                        <input 
                            type="password" 
                            id="password" value={password} 
                            onChange={(e) => setPassword(e.target.value)} 
                            placeholder={t("Enter your new password")} 
                            required 
                            disabled={loading} 
                            className={styles.input} 
                            minLength={6}
                            maxLength={20}
                        />
                    </div>
                    <div className={styles.inputGroup}>
                        <label htmlFor="passwordConfirm" className={styles.label}>{t("Confirm your new password")}:</label>
                        <input 
                            type="password" 
                            id="passwordConfirm" 
                            value={passwordConfirm} 
                            onChange={(e) => setPasswordConfirm(e.target.value)} 
                            placeholder={t("Confirm your new password")} 
                            required 
                            disabled={loading} 
                            className={styles.input} 
                            minLength={6}
                            maxLength={20}
                        />
                    </div>
                    <button type="submit" disabled={loading} className={styles.button}>
                        {loading ? t('Resetting...') : t('Reset Password')}
                    </button>
                </form>
                {message && <p className={styles.message}>{message}</p>}
                {error && <p className={styles.error}>{error}</p>}
            </div>
        </div>
      );
}

export default ResetPassword;